import React, {useContext} from 'react';
import { Container, Spinner, Row } from 'reactstrap';
import { GlobalContext } from '../../context/GlobalContext';

export const Error401 = () => {
    const context = useContext(GlobalContext);
    const { Calificaciones, darkTheme } = context;

    return(
        <Container className={(darkTheme) ? "home__bg-white bg-dark-primary" : "home__bg-white"}>
            <Row style={{ flexDirection: 'column', with: '100vw', justifyContent: 'center', alignItems: 'center', margin: '0' }}>
                <img src="/Images/iconos/buscar@3x.png" alt="Buscar" style={{ width: '176px', height: '150px', marginTop: '100px' }} />
                <span style={{textAlign: 'center'}}>No has iniciado sesión.</span>
            </Row>
        </Container>
    );
}